import reduxStore from '../store/reduxStore'

export const getFlag = (flag) => {
  const state = reduxStore.getState()
  return state.flags.configs[flag]
}
